import React from 'react'
import styled from 'styled-components'

const M = styled.div`
  will-change: visibility, opacity;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1000;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);    
`

const Modal = ({children, style}) => (
  <M style={style}>{children}</M>
)

export default Modal



// WEBPACK FOOTER //
// ./src/basic/Modal.js